import { render } from "./RoleActionMappingsTable.vue?vue&type=template&id=73fb8404&scoped=true&lang=pug"
import script from "./RoleActionMappingsTable.vue?vue&type=script&lang=js"
export * from "./RoleActionMappingsTable.vue?vue&type=script&lang=js"

import "./RoleActionMappingsTable.vue?vue&type=style&index=0&id=73fb8404&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73fb8404"]])

export default __exports__